// extracted by mini-css-extract-plugin
export default {"comment":"Comment_comment__JQOZY","noBorder":"Comment_noBorder__6b3tP","top":"Comment_top__9klv3","avatar":"Comment_avatar__SSxP4"};